import { IndexerPlayer } from "../web3/Types";
import { USDC } from "./UsdcValue";

export class PlayerStatistics {
  ticketsBought: bigint;
  prizesWon: USDC;
  drawsEntered: bigint;
  winningTickets: bigint;
  jackpotsWon: bigint;
  highestPrizeWon: USDC;

  constructor(
    ticketsBought: bigint,
    prizesWon: USDC,
    drawsEntered: bigint,
    winningTickets: bigint,
    jackpotsWon: bigint,
    highestPrizeWon: USDC,
  ) {
    this.ticketsBought = ticketsBought;
    this.prizesWon = prizesWon;
    this.drawsEntered = drawsEntered;
    this.winningTickets = winningTickets;
    this.jackpotsWon = jackpotsWon;
    this.highestPrizeWon = highestPrizeWon;
  }

  static fromGraph(data: IndexerPlayer): PlayerStatistics {
    return new PlayerStatistics(
      BigInt(data?.ticketsBought),
      new USDC(data.prizesWon),
      BigInt(data.drawsEntered),
      BigInt(data.winningTickets),
      BigInt(data.jackpotsWon),
      new USDC(data.highestPrizeWon),
    );
  }

  static empty(): PlayerStatistics {
    return new PlayerStatistics(0n, new USDC(0n), 0n, 0n, 0n, new USDC(0n));
  }
}
